import * as types from "../types";
import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";


export const actionCreators = {

    GetDeploymentsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => async (dispatch, store) => {

        dispatch({ type: types.GET_DEPLOYMENTSLIST_COMPLETED, payload: null });

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Deployment/OrganizationDeployments/" + store().currentuser.currentorganization.id + "?"
                + "pageNumber=" + pageNumber
                + "&pageSize=" + pageSize
                + (sortExpression ? "&sortExpression=" + sortExpression : "")
                + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            dispatch({ type: types.GET_DEPLOYMENTSLIST_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    CancelDeployment: (batchId, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Deployment/Cancel/" + store().currentuser.currentorganization.id + "/" + batchId,
            {
                method: "GET"
            }).then((data) => {
            //toast.success(strings.deploySuccess);
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetDeployment: ( deploymentId, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Deployment/DeploymentStatus/" + deploymentId,
            {
                method: "GET"
            }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    DeploySchedule: (obj, onSuccess) => async (dispatch, store) => {
        toast.success(strings.deployInProgress);
        dispatch({ type: types.CREATE_DEPLOYMENT });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Deployment/" + store().currentuser.currentorganization.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(obj),
            method: "POST"
        }).then((data) => {
            toast.success(strings.deploySuccess);
            dispatch({ type: types.CREATE_DEPLOYMENT_COMPLETED });
            if (onSuccess) {onSuccess();}
        }).catch( (data) => {
            console.log("error", data);
            dispatch({ type: types.CREATE_DEPLOYMENT_FAILED });
        });

    }

};
